// extracted by mini-css-extract-plugin
export default {"heading":"AddPaymentMethodModal_heading__4Jw-3","checkbox":"AddPaymentMethodModal_checkbox__6hW8b"};